<div class="container" (scroll)="onScroll($event)" style="height: 100vh; overflow-y: auto;">
    <div class="row crud-header sticky-header" style="position: sticky; top: 0; z-index: 10; background: #F9FE00;">
        <div class="col flex-shrink-0 text-nowrap d-flex align-items-center gap-3">
            <div routerLink="/{{Routenames.Projects}}/{{Routenames.Map}}"
                 class="controls-left-button"
                 matTooltip="Terug naar projectenkaart"
                 matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <h1 class="mt-2">TVM-tickets</h1>
            <i class="fa fa-2x fa-question-circle" (click)="info()"></i>
        </div>

        <div class="col-12 mt-3">
            <div class="ticket-topbar">
                <div class="topbar-filters w-100 h-100 p-0">
                    <ng-select class="user-select w-100 h-100 p-0"
                               bindLabel="name"
                               bindValue="id"
                               placeholder="Selecteer gebruiker"
                               clearable="true"
                               appearance="outline"
                               [items]="users"
                               [formControl]="userIdControl"></ng-select>
                </div>

                <div class="topbar-search w-100 h-100 p-0">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 h-100 p-0">
                        <mat-label>Zoeken</mat-label>
                        <input #searchInput matInput class="searchInput" placeholder="Zoeken" type="text"/>
                    </mat-form-field>
                </div>

                <div class="topbar-sort w-100 h-100 p-0">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100 h-100 p-0">
                        <mat-label>Sorteer op</mat-label>
                        <mat-select [formControl]="sortByControl">
                            @for (option of sortOptions; track option.value) {
                                <mat-option [value]="option.value">{{option.label}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <button mat-stroked-button type="button" (click)="toggleSortDirection()" class="sort-direction-button" matTooltip="{{sortDirection === 'asc' ? 'Oplopend' : 'Aflopend'}}">
                        <i class="fa" [ngClass]="sortDirection === 'asc' ? 'fa-arrow-up-a-z' : 'fa-arrow-down-z-a'"></i>
                        <span class="sort-label">{{sortDirection === 'asc' ? 'Oplopend' : 'Aflopend'}}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    @if (tickets$ | async; as tickets) {
        @if (tickets.length) {
            <div class="tickets-grid mb-4">
                @for (ticket of tickets; track ticket.id) {
                    <app-ttm-ticket-card
                        [ticket]="ticket"
                        [canDeleteTicket]="canDeleteTicket"
                        (deleteTicket)="delete($event)">
                    </app-ttm-ticket-card>
                }
            </div>
        } @else {
            <div class="empty-state mb-4">Geen tickets gevonden voor de huidige filters.</div>
        }
    }

    @if (loading) {
        <div class="loading-indicator">
            <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
    }
</div>

